export const groupByDate = (data, grouping) => {
  const map = {};

  for (const { date, type, number } of data) {
    let dateGrouped;
    if (grouping && grouping === 'month') {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [day, month, year] = date.split('-');
      dateGrouped = `${month}-${year}`;
    } else {
      dateGrouped = date;
    }

    if (!map[dateGrouped]) {
      map[dateGrouped] = {
        date: dateGrouped,
        BULK: 0,
        MODAL: 0,
        total: 0,
      };
    }

    map[dateGrouped][type] += number;
    map[dateGrouped].total += number;
  }

  return Object.values(map) as {
    date: string;
    BULK: number;
    MODAL: number;
  }[];
};
